import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../endpoints';
import { User } from '../../users';

// ---- Types ----
export interface FormAccess {
    _id: string;
    groupId: string;
    userId: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface FormAccessWithUser extends FormAccess {
    user: User;
}

export interface FormAccessResponse {
    message: string;
    data: FormAccess;
}

export interface FormAccessListResponse {
    message: string;
    data: FormAccess[];
}

export interface FormAccessWithUserListResponse {
    message: string;
    data: FormAccessWithUser[];
}

export interface CreateFormAccessBody {
    groupId: string;
    userId: string;
}

// ---- GET BY USER ID ----
export const getFormAccessByUserId = async (userId: string): Promise<FormAccessListResponse> => {
    try {
        const response: AxiosResponse<FormAccessListResponse> = await apiClient.get(`/form-access/user/${userId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// ---- GET BY Active USERS ----
export const getFormAccessByActiveUsers = async (): Promise<FormAccessListResponse> => {
    try {
        const response: AxiosResponse<FormAccessListResponse> = await apiClient.get(`/form-access/active-users`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// ---- GET BY GROUP ID ----
export const getFormAccessByGroupId = async (groupId: string): Promise<FormAccessWithUserListResponse> => {
    try {
        const response: AxiosResponse<FormAccessWithUserListResponse> = await apiClient.get(`/form-access/group/${groupId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// ---- CREATE ----
export const createFormAccess = async (data: CreateFormAccessBody): Promise<FormAccessResponse> => {
    try {
        const response: AxiosResponse<FormAccessResponse> = await apiClient.post(`/form-access`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// ---- DELETE ----
export const deleteFormAccess = async (id: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/form-access/${id}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
